import { cn } from '~/utils/classnames'

const Switch = ({
  className,
  ...props
}: Omit<React.ComponentPropsWithRef<'input'>, 'type'>) => {
  return (
    <input
      type="checkbox"
      className={cn(
        'shrink-0',
        'appearance-none',
        'relative h-5 w-9 cursor-pointer rounded-xl transition',
        // circle
        'before:ease-out-expo before:bg-highlight before:absolute before:top-1/2 before:left-0.5 before:size-4 before:-translate-y-1/2 before:rounded-xl before:shadow-lg before:drop-shadow-md before:transition-transform before:duration-200',
        // disabled
        'disabled:before:opacity-30',
        // checked
        'checked:before:translate-x-full',
        // focus
        'focus-visible:ring-ring focus-visible:ring-4 focus-visible:outline-none',
        // stretch animation
        'before:origin-left active:before:scale-x-120 active:before:rounded-[calc(var(--spacing)*1.8)] active:checked:before:origin-right',
        // default
        'bg-under/12 checked:bg-accent-element',
        // dark
        'dark:bg-foreground/20 dark:checked:bg-accent-element/48',
        // overall
        'overall:bg-foreground/12 overall:checked:bg-accent-element/80',
        className
      )}
      {...props}
    />
  )
}

export { Switch }
